// Improvement loop — errors and feedback (FeedbackButton.jsx, 69_ImprovementLoop.jsx), 2026-11-02, Jay tasks #1137 / #1138.
const en = {
  envThis: 'This server',
  fbButton: 'Feedback',
  fbTitle: 'Send feedback',
  fbIntro: "Tell us what went wrong or what could be better on this screen. Attach a file, or paste a screenshot with Ctrl+V, to show it.",
  fbBug: 'Bug',
  fbBugHint: 'Something is broken or wrong',
  fbHard: 'Hard to use',
  fbHardHint: 'It works, but it is slow or confusing',
  fbIdea: 'Idea',
  fbIdeaHint: 'Something that would help',
  fbNote: 'Note (optional)',
  fbNotePh: 'What happened, or what you would like…',
  fbScreen: 'Screen',
  fbSend: 'Send',
  fbSending: 'Sending…',
  fbThanks: 'Thank you — Max will see it. You can follow it under My feedback.',
  fbPick: 'Pick Bug, Hard to use or Idea first.',
  fbMine: 'My feedback',
  fbNone: 'You have not sent any feedback yet.',
  fbReply: 'Answer',
  fbTask: 'Task',
  stNew: 'New',
  stSeen: 'Seen',
  stPlanned: 'Planned',
  stDone: 'Done',
  stWont: 'Not planned',
  close: 'Close',
  title: 'Improvement loop',
  sub: 'Errors from the server and the screens, and the feedback people send. Raw rows are for Admins; the 16:00 report groups them by screen and role.',
  tabErrors: 'Errors',
  tabFeedback: 'Feedback',
  tabSettings: 'Settings',
  env: 'Server',
  days: 'Last {{n}} days',
  refresh: 'Refresh',
  clearFilters: 'Clear filters',
  shownOf: '{{n}} of {{m}}',
  colStatus: 'Status',
  colSource: 'Source',
  colKind: 'Kind',
  colMessage: 'Error',
  colScreen: 'Screen',
  colRole: 'Role',
  colApi: 'API',
  colHits: 'Count',
  colFirst: 'First seen',
  colLast: 'Last seen',
  colLastUser: 'Last user',
  colAction: 'Action',
  colDate: 'Date',
  colType: 'Type',
  colNote: 'Note',
  colFrom: 'From',
  colReply: 'Answer to the sender',
  colTask: 'Task',
  markKnown: 'Known',
  markFixed: 'Fixed',
  markIgnore: 'Ignore',
  markNew: 'Reopen',
  esNew: 'New',
  esKnown: 'Known',
  esFixed: 'Fixed',
  esIgnored: 'Ignored',
  detail: 'Details',
  save: 'Save',
  saved: 'Saved.',
  noErrors: 'No errors in this period.',
  noFeedback: 'No feedback yet.',
  setIntro: 'What is logged and collected. Off = nothing of that kind is recorded from now on (rows already kept stay).',
  setErrors: 'Errors',
  setFeedback: 'Feedback',
  on: 'On',
  off: 'Off',
  server: 'server / job',
  srcServer: 'Server',
  srcScreen: 'Screen',
  replyPh: 'Shown to the sender',
  taskPh: 'TSK-…',
  fbAttach: "Attach a file",
  fbPasteHint: "or paste a screenshot (Ctrl+V) — up to 5 files, 10 MB each",
  fbTooBig: "{{name}} is over {{mb}} MB.",
  fbTooMany: "Up to {{n}} files.",
  fbRemove: "Remove {{name}}",
  fbFileFailed: "Your feedback was sent, but these files could not be attached: {{names}}.",
  fbQueuedNoFiles: "The portal could not be reached, so your note will be sent later — without the files. Please send them again once it is back.",
  fbView: "Open to check it",
  colNo: "No.",
  colFeedback: "Feedback",
  all: "All",
  you: "you",
  lastBy: "Last update by {{name}} · {{when}}",
  saveAnswer: "Save answer",
  newTab: "Open in a new tab",
};
const ko = {
  envThis: '이 서버',
  fbButton: '피드백',
  fbTitle: '피드백 보내기',
  fbIntro: "이 화면에서 잘못된 점이나 개선할 점을 알려 주세요. 파일을 첨부하거나 Ctrl+V로 스크린샷을 붙여 넣어 보여 주세요.",
  fbBug: '버그',
  fbBugHint: '고장 났거나 잘못된 부분',
  fbHard: '사용 불편',
  fbHardHint: '작동은 하지만 느리거나 헷갈림',
  fbIdea: '아이디어',
  fbIdeaHint: '있으면 도움이 될 기능',
  fbNote: '메모 (선택)',
  fbNotePh: '무슨 일이 있었는지, 또는 원하는 점…',
  fbScreen: '화면',
  fbSend: '보내기',
  fbSending: '보내는 중…',
  fbThanks: '감사합니다. Max가 확인합니다. 진행 상황은 내 피드백에서 볼 수 있습니다.',
  fbPick: '먼저 버그, 사용 불편, 아이디어 중 하나를 선택하세요.',
  fbMine: '내 피드백',
  fbNone: '아직 보낸 피드백이 없습니다.',
  fbReply: '답변',
  fbTask: '작업',
  stNew: '신규',
  stSeen: '확인함',
  stPlanned: '예정',
  stDone: '완료',
  stWont: '진행 안 함',
  close: '닫기',
  title: '개선 루프',
  sub: '서버와 화면에서 발생한 오류, 그리고 사용자가 보낸 피드백입니다. 원본은 관리자만 볼 수 있고, 16:00 보고서는 화면과 역할별로 묶어 보여 줍니다.',
  tabErrors: '오류',
  tabFeedback: '피드백',
  tabSettings: '설정',
  env: '서버',
  days: '최근 {{n}}일',
  refresh: '새로고침',
  clearFilters: '필터 지우기',
  shownOf: '{{m}}건 중 {{n}}건',
  colStatus: '상태',
  colSource: '출처',
  colKind: '종류',
  colMessage: '오류',
  colScreen: '화면',
  colRole: '역할',
  colApi: 'API',
  colHits: '횟수',
  colFirst: '최초 발생',
  colLast: '최근 발생',
  colLastUser: '최근 사용자',
  colAction: '작업',
  colDate: '날짜',
  colType: '유형',
  colNote: '메모',
  colFrom: '보낸 사람',
  colReply: '보낸 사람에게 답변',
  colTask: '작업',
  markKnown: '확인됨',
  markFixed: '수정됨',
  markIgnore: '무시',
  markNew: '다시 열기',
  esNew: '신규',
  esKnown: '확인됨',
  esFixed: '수정됨',
  esIgnored: '무시됨',
  detail: '상세',
  save: '저장',
  saved: '저장했습니다.',
  noErrors: '이 기간에는 오류가 없습니다.',
  noFeedback: '아직 피드백이 없습니다.',
  setIntro: '기록하고 수집할 항목입니다. 끄면 지금부터 그 종류는 기록하지 않습니다(이미 저장된 행은 남습니다).',
  setErrors: '오류',
  setFeedback: '피드백',
  on: '켜짐',
  off: '꺼짐',
  server: '서버 / 작업',
  srcServer: '서버',
  srcScreen: '화면',
  replyPh: '보낸 사람에게 표시됩니다',
  taskPh: 'TSK-…',
  fbAttach: "파일 첨부",
  fbPasteHint: "또는 스크린샷 붙여 넣기(Ctrl+V) — 최대 5개, 파일당 10MB",
  fbTooBig: "{{name}}이(가) {{mb}}MB를 넘습니다.",
  fbTooMany: "최대 {{n}}개 파일입니다.",
  fbRemove: "{{name}} 삭제",
  fbFileFailed: "피드백은 보냈지만 다음 파일을 첨부하지 못했습니다: {{names}}.",
  fbQueuedNoFiles: "포털에 연결되지 않아 메모는 나중에 보내집니다 — 파일은 제외됩니다. 연결되면 파일을 다시 보내 주세요.",
  fbView: "열어서 확인",
  colNo: "번호",
  colFeedback: "피드백",
  all: "전체",
  you: "나",
  lastBy: "최근 수정 {{name}} · {{when}}",
  saveAnswer: "답변 저장",
  newTab: "새 탭에서 열기",
};
const vi = {
  envThis: 'Server này',
  fbButton: 'Góp ý',
  fbTitle: 'Gửi góp ý',
  fbIntro: "Cho chúng tôi biết màn hình này có gì sai hoặc nên cải thiện gì. Đính kèm file, hoặc dán ảnh chụp màn hình bằng Ctrl+V, để minh hoạ.",
  fbBug: 'Lỗi',
  fbBugHint: 'Có gì đó hỏng hoặc sai',
  fbHard: 'Khó dùng',
  fbHardHint: 'Dùng được nhưng chậm hoặc rối',
  fbIdea: 'Ý tưởng',
  fbIdeaHint: 'Điều gì đó sẽ giúp ích',
  fbNote: 'Ghi chú (không bắt buộc)',
  fbNotePh: 'Chuyện gì đã xảy ra, hoặc bạn muốn gì…',
  fbScreen: 'Màn hình',
  fbSend: 'Gửi',
  fbSending: 'Đang gửi…',
  fbThanks: 'Cảm ơn bạn — Max sẽ xem. Bạn theo dõi ở mục Góp ý của tôi.',
  fbPick: 'Chọn Lỗi, Khó dùng hoặc Ý tưởng trước nhé.',
  fbMine: 'Góp ý của tôi',
  fbNone: 'Bạn chưa gửi góp ý nào.',
  fbReply: 'Trả lời',
  fbTask: 'Task',
  stNew: 'Mới',
  stSeen: 'Đã xem',
  stPlanned: 'Đã lên kế hoạch',
  stDone: 'Đã xong',
  stWont: 'Không làm',
  close: 'Đóng',
  title: 'Improvement loop',
  sub: 'Lỗi từ server và các màn hình, cùng góp ý mọi người gửi. Dữ liệu gốc chỉ Admin xem; báo cáo 16:00 gộp theo màn hình và role.',
  tabErrors: 'Lỗi',
  tabFeedback: 'Góp ý',
  tabSettings: 'Cài đặt',
  env: 'Server',
  days: '{{n}} ngày gần nhất',
  refresh: 'Tải lại',
  clearFilters: 'Xóa lọc',
  shownOf: '{{n}} / {{m}}',
  colStatus: 'Trạng thái',
  colSource: 'Nguồn',
  colKind: 'Loại',
  colMessage: 'Lỗi',
  colScreen: 'Màn hình',
  colRole: 'Role',
  colApi: 'API',
  colHits: 'Số lần',
  colFirst: 'Lần đầu',
  colLast: 'Lần gần nhất',
  colLastUser: 'Người gặp gần nhất',
  colAction: 'Thao tác',
  colDate: 'Ngày',
  colType: 'Loại',
  colNote: 'Ghi chú',
  colFrom: 'Người gửi',
  colReply: 'Trả lời người gửi',
  colTask: 'Task',
  markKnown: 'Đã biết',
  markFixed: 'Đã sửa',
  markIgnore: 'Bỏ qua',
  markNew: 'Mở lại',
  esNew: 'Mới',
  esKnown: 'Đã biết',
  esFixed: 'Đã sửa',
  esIgnored: 'Bỏ qua',
  detail: 'Chi tiết',
  save: 'Lưu',
  saved: 'Đã lưu.',
  noErrors: 'Không có lỗi trong khoảng này.',
  noFeedback: 'Chưa có góp ý.',
  setIntro: 'Những gì được ghi lại và thu thập. Tắt = từ giờ không ghi loại đó nữa (các dòng đã có vẫn giữ).',
  setErrors: 'Lỗi',
  setFeedback: 'Góp ý',
  on: 'Bật',
  off: 'Tắt',
  server: 'server / job',
  srcServer: 'Server',
  srcScreen: 'Màn hình',
  replyPh: 'Người gửi sẽ thấy',
  taskPh: 'TSK-…',
  fbAttach: "Đính kèm file",
  fbPasteHint: "hoặc dán ảnh chụp màn hình (Ctrl+V) — tối đa 5 file, mỗi file 10 MB",
  fbTooBig: "{{name}} nặng hơn {{mb}} MB.",
  fbTooMany: "Tối đa {{n}} file.",
  fbRemove: "Xoá {{name}}",
  fbFileFailed: "Góp ý đã gửi, nhưng không đính kèm được các file: {{names}}.",
  fbQueuedNoFiles: "Hiện không kết nối được portal nên góp ý sẽ được gửi sau — không kèm file. Khi kết nối lại, bạn gửi lại file giúp nhé.",
  fbView: "Mở để kiểm tra",
  colNo: "Số",
  colFeedback: "Góp ý",
  all: "Tất cả",
  you: "bạn",
  lastBy: "Cập nhật lần cuối: {{name}} · {{when}}",
  saveAnswer: "Lưu trả lời",
  newTab: "Mở ở tab mới",
};
const zh = {
  envThis: '本服务器',
  fbButton: '反馈',
  fbTitle: '发送反馈',
  fbIntro: "告诉我们这个页面哪里有问题或可以改进。可以附上文件，或用 Ctrl+V 粘贴截图来说明。",
  fbBug: '错误',
  fbBugHint: '有东西坏了或不对',
  fbHard: '不好用',
  fbHardHint: '能用，但慢或让人困惑',
  fbIdea: '建议',
  fbIdeaHint: '会有帮助的功能',
  fbNote: '备注（可选）',
  fbNotePh: '发生了什么，或你希望怎样…',
  fbScreen: '页面',
  fbSend: '发送',
  fbSending: '发送中…',
  fbThanks: '谢谢，Max 会看到。可以在“我的反馈”中查看进度。',
  fbPick: '请先选择 错误、不好用 或 建议。',
  fbMine: '我的反馈',
  fbNone: '你还没有发送过反馈。',
  fbReply: '回复',
  fbTask: '任务',
  stNew: '新',
  stSeen: '已查看',
  stPlanned: '已计划',
  stDone: '已完成',
  stWont: '不处理',
  close: '关闭',
  title: '改进循环',
  sub: '来自服务器和页面的错误，以及大家发送的反馈。原始记录仅管理员可见；16:00 报告按页面和角色汇总。',
  tabErrors: '错误',
  tabFeedback: '反馈',
  tabSettings: '设置',
  env: '服务器',
  days: '最近 {{n}} 天',
  refresh: '刷新',
  clearFilters: '清除筛选',
  shownOf: '{{n}} / {{m}}',
  colStatus: '状态',
  colSource: '来源',
  colKind: '类型',
  colMessage: '错误',
  colScreen: '页面',
  colRole: '角色',
  colApi: 'API',
  colHits: '次数',
  colFirst: '首次出现',
  colLast: '最近出现',
  colLastUser: '最近用户',
  colAction: '操作',
  colDate: '日期',
  colType: '类型',
  colNote: '备注',
  colFrom: '发送人',
  colReply: '回复发送人',
  colTask: '任务',
  markKnown: '已知',
  markFixed: '已修复',
  markIgnore: '忽略',
  markNew: '重新打开',
  esNew: '新',
  esKnown: '已知',
  esFixed: '已修复',
  esIgnored: '已忽略',
  detail: '详情',
  save: '保存',
  saved: '已保存。',
  noErrors: '此期间没有错误。',
  noFeedback: '还没有反馈。',
  setIntro: '记录和收集的内容。关闭后，从现在起不再记录该类型（已有记录保留）。',
  setErrors: '错误',
  setFeedback: '反馈',
  on: '开',
  off: '关',
  server: '服务器 / 任务',
  srcServer: '服务器',
  srcScreen: '页面',
  replyPh: '发送人可以看到',
  taskPh: 'TSK-…',
  fbAttach: "附加文件",
  fbPasteHint: "或粘贴截图（Ctrl+V）— 最多 5 个文件，每个 10 MB",
  fbTooBig: "{{name}} 超过 {{mb}} MB。",
  fbTooMany: "最多 {{n}} 个文件。",
  fbRemove: "删除 {{name}}",
  fbFileFailed: "反馈已发送，但以下文件未能附上：{{names}}。",
  fbQueuedNoFiles: "暂时无法连接门户，备注稍后发送 — 不含文件。恢复后请重新发送文件。",
  fbView: "打开查看",
  colNo: "编号",
  colFeedback: "反馈",
  all: "全部",
  you: "你",
  lastBy: "最近更新 {{name}} · {{when}}",
  saveAnswer: "保存回复",
  newTab: "在新标签页打开",
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "envThis": "Ce serveur",
  "fbButton": "Retour d’expérience",
  "fbTitle": "Envoyer un retour",
  "fbIntro": "Dites-nous ce qui ne va pas ou ce qui pourrait être amélioré sur cet écran. Joignez un fichier ou collez une capture d’écran avec Ctrl+V pour l’illustrer.",
  "fbBug": "Bug",
  "fbBugHint": "Quelque chose est cassé ou incorrect",
  "fbHard": "Difficile à utiliser",
  "fbHardHint": "Cela fonctionne, mais c’est lent ou confus",
  "fbIdea": "Idée",
  "fbIdeaHint": "Quelque chose qui serait utile",
  "fbNote": "Remarque (facultatif)",
  "fbNotePh": "Ce qui s’est passé, ou ce que vous souhaiteriez…",
  "fbScreen": "Écran",
  "fbSend": "Envoyer",
  "fbSending": "Envoi…",
  "fbThanks": "Merci — Max le verra. Vous pouvez le suivre dans Mes retours.",
  "fbPick": "Choisissez d’abord Bug, Difficile à utiliser ou Idée.",
  "fbMine": "Mes retours",
  "fbNone": "Vous n’avez encore envoyé aucun retour.",
  "fbReply": "Réponse",
  "fbTask": "Tâche",
  "stNew": "Nouveau",
  "stSeen": "Vu",
  "stPlanned": "Planifié",
  "stDone": "Terminé",
  "stWont": "Non prévu",
  "close": "Fermer",
  "title": "Boucle d’amélioration",
  "sub": "Erreurs du serveur et des écrans, et retours envoyés par les utilisateurs. Les lignes brutes sont réservées aux Admins ; le rapport de 16:00 les regroupe par écran et par rôle.",
  "tabErrors": "Erreurs",
  "tabFeedback": "Retours",
  "tabSettings": "Paramètres",
  "env": "Serveur",
  "days": "{{n}} derniers jours",
  "refresh": "Actualiser",
  "clearFilters": "Effacer les filtres",
  "shownOf": "{{n}} sur {{m}}",
  "colStatus": "Statut",
  "colSource": "Source",
  "colKind": "Type",
  "colMessage": "Erreur",
  "colScreen": "Écran",
  "colRole": "Rôle",
  "colApi": "API",
  "colHits": "Nombre",
  "colFirst": "Première occurrence",
  "colLast": "Dernière occurrence",
  "colLastUser": "Dernier utilisateur",
  "colAction": "Action",
  "colDate": "Date",
  "colType": "Type",
  "colNote": "Remarque",
  "colFrom": "De",
  "colReply": "Réponse à l’expéditeur",
  "colTask": "Tâche",
  "markKnown": "Connu",
  "markFixed": "Corrigé",
  "markIgnore": "Ignorer",
  "markNew": "Rouvrir",
  "esNew": "Nouveau",
  "esKnown": "Connu",
  "esFixed": "Corrigé",
  "esIgnored": "Ignoré",
  "detail": "Détails",
  "save": "Enregistrer",
  "saved": "Enregistré.",
  "noErrors": "Aucune erreur sur cette période.",
  "noFeedback": "Aucun retour pour le moment.",
  "setIntro": "Ce qui est journalisé et collecté. Désactivé = plus rien de ce type n’est enregistré à partir de maintenant (les lignes déjà conservées restent).",
  "setErrors": "Erreurs",
  "setFeedback": "Retours",
  "on": "Activé",
  "off": "Désactivé",
  "server": "serveur / job",
  "srcServer": "Serveur",
  "srcScreen": "Écran",
  "replyPh": "Affiché à l’expéditeur",
  "taskPh": "TSK-…",
  "fbAttach": "Joindre un fichier",
  "fbPasteHint": "ou collez une capture d’écran (Ctrl+V) — jusqu’à 5 fichiers, 10 MB chacun",
  "fbTooBig": "{{name}} dépasse {{mb}} MB.",
  "fbTooMany": "Jusqu’à {{n}} fichiers.",
  "fbRemove": "Retirer {{name}}",
  "fbFileFailed": "Votre retour a été envoyé, mais ces fichiers n’ont pas pu être joints : {{names}}.",
  "fbQueuedNoFiles": "Le portail était injoignable : votre remarque sera envoyée plus tard, sans les fichiers. Merci de les renvoyer une fois le portail rétabli.",
  "fbView": "Ouvrir pour vérifier",
  "colNo": "N°",
  "colFeedback": "Retour",
  "all": "Tous",
  "you": "vous",
  "lastBy": "Dernière mise à jour par {{name}} · {{when}}",
  "saveAnswer": "Enregistrer la réponse",
  "newTab": "Ouvrir dans un nouvel onglet"
};
const ja = {
  "envThis": "このサーバー",
  "fbButton": "フィードバック",
  "fbTitle": "フィードバックを送信",
  "fbIntro": "この画面で問題があったこと、または改善できそうなことをお知らせください。ファイルを添付するか、Ctrl+Vでスクリーンショットを貼り付けると状況が伝わります。",
  "fbBug": "不具合",
  "fbBugHint": "壊れている、または正しくない",
  "fbHard": "使いにくい",
  "fbHardHint": "動作はするが、遅い、または分かりにくい",
  "fbIdea": "アイデア",
  "fbIdeaHint": "あると役に立つこと",
  "fbNote": "メモ（任意）",
  "fbNotePh": "起きたことや、希望することを書いてください…",
  "fbScreen": "画面",
  "fbSend": "送信",
  "fbSending": "送信中…",
  "fbThanks": "ありがとうございます。Maxが確認します。「自分のフィードバック」で進捗を確認できます。",
  "fbPick": "先に「不具合」「使いにくい」「アイデア」のいずれかを選んでください。",
  "fbMine": "自分のフィードバック",
  "fbNone": "まだフィードバックを送信していません。",
  "fbReply": "回答",
  "fbTask": "タスク",
  "stNew": "新規",
  "stSeen": "確認済み",
  "stPlanned": "対応予定",
  "stDone": "完了",
  "stWont": "対応しない",
  "close": "閉じる",
  "title": "改善ループ",
  "sub": "サーバーと各画面のエラー、およびユーザーから届いたフィードバックです。生データはAdminのみが見られます。16:00のレポートでは、画面とロールごとにまとめられます。",
  "tabErrors": "エラー",
  "tabFeedback": "フィードバック",
  "tabSettings": "設定",
  "env": "サーバー",
  "days": "過去{{n}}日間",
  "refresh": "更新",
  "clearFilters": "フィルターをクリア",
  "shownOf": "{{m}}件中{{n}}件",
  "colStatus": "ステータス",
  "colSource": "ソース",
  "colKind": "種別",
  "colMessage": "エラー",
  "colScreen": "画面",
  "colRole": "ロール",
  "colApi": "API",
  "colHits": "件数",
  "colFirst": "初回発生",
  "colLast": "最終発生",
  "colLastUser": "最後のユーザー",
  "colAction": "操作",
  "colDate": "日付",
  "colType": "タイプ",
  "colNote": "メモ",
  "colFrom": "送信者",
  "colReply": "送信者への回答",
  "colTask": "タスク",
  "markKnown": "既知",
  "markFixed": "修正済み",
  "markIgnore": "無視",
  "markNew": "再オープン",
  "esNew": "新規",
  "esKnown": "既知",
  "esFixed": "修正済み",
  "esIgnored": "無視",
  "detail": "詳細",
  "save": "保存",
  "saved": "保存しました。",
  "noErrors": "この期間にエラーはありません。",
  "noFeedback": "フィードバックはまだありません。",
  "setIntro": "記録・収集する内容です。オフにすると、その種類のデータは今後記録されません（すでに保存された行は残ります）。",
  "setErrors": "エラー",
  "setFeedback": "フィードバック",
  "on": "オン",
  "off": "オフ",
  "server": "サーバー / ジョブ",
  "srcServer": "サーバー",
  "srcScreen": "画面",
  "replyPh": "送信者に表示されます",
  "taskPh": "TSK-…",
  "fbAttach": "ファイルを添付",
  "fbPasteHint": "またはスクリーンショットを貼り付け（Ctrl+V）— 最大5ファイル、各10 MBまで",
  "fbTooBig": "{{name}}は{{mb}} MBを超えています。",
  "fbTooMany": "最大{{n}}ファイルまでです。",
  "fbRemove": "{{name}}を削除",
  "fbFileFailed": "フィードバックは送信されましたが、次のファイルは添付できませんでした：{{names}}。",
  "fbQueuedNoFiles": "ポータルに接続できなかったため、メモは後で送信されます。ファイルは含まれません。復旧後に、ファイルをもう一度送信してください。",
  "fbView": "開いて確認",
  "colNo": "No.",
  "colFeedback": "フィードバック",
  "all": "すべて",
  "you": "自分",
  "lastBy": "最終更新：{{name}} · {{when}}",
  "saveAnswer": "回答を保存",
  "newTab": "新しいタブで開く"
};

const dictionary = { ns: 'xLoop', en, ko, vi, zh, fr, ja };
export default dictionary;
